/* Flechas de "Sumá a tu compra".

   El deslizamiento lo hace el navegador: el viewport tiene overflow-x y scroll-snap, asi que
   con el dedo y con la rueda ya funciona sin una linea de JS. Lo unico que agrega este
   archivo son las dos flechas, y por eso el CSS las deja ocultas hasta :defined — un boton
   que no responde es peor que no tenerlo.

   Se mueve de a UNA tarjeta y no una cantidad fija de pixeles: el ancho cambia con el
   viewport, y restar 300px a ojo deja las tarjetas cortadas a la mitad. */
class FpCrossSell extends HTMLElement {
  #viewport = null;
  #antes = null;
  #despues = null;

  connectedCallback() {
    this.#viewport = this.querySelector('.fp-xs__viewport');
    this.#antes = this.querySelector('.fp-xs__flecha--antes');
    this.#despues = this.querySelector('.fp-xs__flecha--despues');
    if (!this.#viewport) return;

    this.#antes?.addEventListener('click', () => this.#mover(-1));
    this.#despues?.addEventListener('click', () => this.#mover(1));

    /* rAF para no recalcular en cada evento de scroll: llegan muchos por segundo y lo unico
       que se hace es prender o apagar dos atributos. */
    let pedido = false;
    this.#viewport.addEventListener(
      'scroll',
      () => {
        if (pedido) return;
        pedido = true;
        requestAnimationFrame(() => {
          pedido = false;
          this.#marcarBordes();
        });
      },
      { passive: true }
    );

    this.#marcarBordes();
    if ('ResizeObserver' in window) new ResizeObserver(() => this.#marcarBordes()).observe(this.#viewport);
  }

  #paso() {
    const item = this.querySelector('.fp-xs__item');
    if (!item) return this.#viewport.clientWidth;
    const track = this.querySelector('.fp-xs__track');
    const hueco = track ? parseFloat(getComputedStyle(track).gap) || 0 : 0;
    return item.getBoundingClientRect().width + hueco;
  }

  #mover(sentido) {
    this.#viewport.scrollBy({ left: this.#paso() * sentido, behavior: 'smooth' });
  }

  #marcarBordes() {
    const v = this.#viewport;
    /* 2px de tolerancia: con zoom o en pantallas de densidad rara, scrollLeft queda en
       valores como 0.5 y el borde nunca se daria por alcanzado. */
    const alInicio = v.scrollLeft <= 2;
    const alFinal = v.scrollLeft + v.clientWidth >= v.scrollWidth - 2;
    this.#antes?.toggleAttribute('disabled', alInicio);
    this.#despues?.toggleAttribute('disabled', alFinal);
  }
}

if (!customElements.get('fp-cross-sell')) {
  customElements.define('fp-cross-sell', FpCrossSell);
}
